export const BRAND_DOMAINS = {
  XO268: "XO268.GG",
  WOW69: "WOW69.COM",
  MK69: "MK69.NET",
  DEE99: "DEE99.GG",
  HK39: "HK39.COM",
  BIG188: "BIG188.COM",
  W268: "W268.COM",
  KISS39: "KISS39.COM",
  POP369: "POP369.COM",
  CY268: "CY268.COM",
  "789BK": "789BK.NET",
  JAI88: "JAI88.NET",
  SUK555: "SUK555.NET",
  GOGO69: "GOGO69.COM",
  RM99: "RM99.GG",
  RNG999: "RNG999.COM",
  XC69: "XC69.COM",
  TRU99: "TRU99.COM",
  KBK99: "KBK99.GG",
  GO989: "GO989.GG",
  KK69: "KK69.COM",
  MOO555: "MOO555.GG",
} as const;
